import React from "react";
import Gallery from 'react-grid-gallery';



// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

// @material-ui/icons



import CustomInput from "components/CustomInput/CustomInput.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardCategory: {
    margin: "0",
    color: "#999999"
  }
};

export class MeterDisconnection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { classes } = this.props;

    const customerSignature = [
      {
        src: "https://shopvida.zendesk.com/hc/article_attachments/360001259688/signature.jpeg",
        thumbnail: "https://shopvida.zendesk.com/hc/article_attachments/360001259688/signature.jpeg",
        thumbnailWidth: 320,
        thumbnailHeight: 174,
      },
    ]

    const job = this.props.job

    const contractorWork = {
      standFound: job.work ? job.work.standFound : false,
      accessToProperty: job.work ? job.work.accessToProperty : false,
      kioskiLocated: job.work ? job.work.kioskiLocated : false,
      kioskiAccessLock: job.work ? job.work.kioskiAccessLock : false,
      kioskiStatus: job.work ? job.work.kioskiStatus : false,
      meterNumber: job.work ? job.work.meterInformation.meterNumber : '- - - - -',
      meterReading: job.work ? job.work.meterInformation.meterReading : '- - - - -',
      serialNumber: job.work ? job.work.meterInformation.serialNumber : '- - - - -',
      correctMeterInstalled: job.work ? job.work.correctMeterInstalled : false,
      meterSecurelyInstalled: job.work ? job.work.meterSecurelyInstalled : false,
      meterSealed: job.work ? job.work.meterSealed : false,
      meterLabeled: job.work ? job.work.meterLabeled : false,
      cbInKioskiSecured: job.work ? job.work.cbInKioskiSecured : false,
      cbInKioskiLabeled: job.work ? job.work.cbInKioskiLabeled : false,
      keypadLabeled: job.work ? job.work.keypadLabeled : false,
      communicationWithKeypad: job.work ? job.work.communicationWithKeypad : false,
      tokenAdded: job.work ? job.work.tokenAdded : false,
      totalUnits: job.work ? job.work.totalUnits : '- - - - -',
      customerAvailable: job.work ? job.work.customerAvailable : false,
      customerAdviced: job.work ? job.work.customerAdviced : false,
      customerReceivedPrepaymentCard: job.work ? job.work.customerReceivedPrepaymentCard : false,
      customerTreatedFriendly: job.work ? job.work.customerTreatedFriendly : false,
      customerReceivedPamphlet: job.work ? job.work.customerReceivedPamphlet : false,
      customerContact: job.work ? job.work.customerContact : '- - - - -',
      remarks: job.work ? job.work.remarks : '- - - - -',
    }
    const inspectorWork = {
      cbInSecurelyInstalled: job.postInspectionWork ? job.postInspectionWork.cbInSecurelyInstalled : false,
      remarks: job.postInspectionWork ? job.postInspectionWork.remarks : '- - - - -',

      standFound: job.postInspectionWork ? job.postInspectionWork.standFound : false,
      accessToProperty: job.postInspectionWork ? job.postInspectionWork.accessToProperty : false,
      kioskiLocated: job.postInspectionWork ? job.postInspectionWork.kioskiLocated : false,
      kioskiAccessLock: job.postInspectionWork ? job.postInspectionWork.kioskiAccessLock : false,
      kioskiStatus: job.postInspectionWork ? job.postInspectionWork.kioskiStatus : false,
      meterNumber: job.postInspectionWork ? job.postInspectionWork.meterInformation.meterNumber : '- - - - -',
      meterReading: job.postInspectionWork ? job.postInspectionWork.meterInformation.meterReading : '- - - - -',
      serialNumber: job.postInspectionWork ? job.postInspectionWork.meterInformation.serialNumber : '- - - - -',
      meterSecurelyInstalled: job.postInspectionWork ? job.postInspectionWork.meterSecurelyInstalled : false,
      meterLabeled: job.postInspectionWork ? job.postInspectionWork.meterLabeled : false,
      cbLabeled: job.postInspectionWork ? job.postInspectionWork.cbLabeled : false,
      communicationWithKeypad: job.postInspectionWork ? job.postInspectionWork.communicationWithKeypad : false,
      acceptableWiringAndLabel: job.postInspectionWork ? job.postInspectionWork.acceptableWiringAndLabel : false,
      meterTempered: job.postInspectionWork ? job.postInspectionWork.meterTempered : false,
      isJobcardPassed: job.postInspectionWork ? job.postInspectionWork.isJobcardPassed : false,
      standComment: job.postInspectionWork ? job.postInspectionWork.standComment : '- - - - -',
      standContactPerson: job.postInspectionWork ? job.postInspectionWork.standContactPerson : '- - - - -',
      standContactPersonPhone: job.work ? job.work.standContactPersonPhone : '- - - - -',

    }



    const inspectorImages = (this.props.job.postInspectionWork ? this.props.job.postInspectionWork.imageResources : []).map((img, index) => ({
      key: index,
      thumbnail: img.url,
      src: img.url,
      thumbnailHeight: 174,
      thumbnailWidth: 320,
      caption: img.description,
      tags: [{ value: <span style={{ color: "#fff" }}>{img.title} </span> }],
    }));

    const contractorImages = (this.props.job.work ? this.props.job.work.imageResources : []).map((img, index) => ({
      key: index,
      thumbnail: img.url,
      src: img.url,
      thumbnailHeight: 174,
      thumbnailWidth: 320,
      caption: img.description,
      tags: [{ value: <span style={{ color: "#fff" }}>{img.title} </span> }],

    }));




    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>


          <NavPills
            color="danger"
            alignCenter
            tabs={[
              {
                tabButton: "Contractor Sumbitted Work",
                tabContent: (

                  <Card>
                    <CardBody>

                      <GridContainer xs={12} sm={9} md={9} style={{ margin: "auto", display: !job.work ? 'block' : 'none', }} >
                        <p> No Work Submitted yet</p>
                      </GridContainer>,
  
                    {job.work ? <GridContainer xs={12} sm={9} md={9} style={{ margin: "auto" }} >
                        <GridItem xs={12} sm={12} md={12}>
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Contractor Images</h4>

                          <Gallery
                            images={contractorImages}
                            enableLightbox={true}
                            enableImageSelection={false}
                          />
                        </GridItem>


                        <GridItem xs={12} sm={12} md={12}>
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Stand Recorded Info</h4>
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you find the stand?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.standFound}
                                value={contractorWork.standFound}
                              />
                            }

                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you had access into property?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.accessToProperty}
                                value={contractorWork.accessToProperty}
                              />
                            }
                          />
                        </GridItem>



                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Kioski Info</h4>
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you locate Kioski?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.kioskiLocated}
                                value={contractorWork.kioskiLocated}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you had access into Kioski</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.kioskiAccessLock}
                                value={contractorWork.kioskiAccessLock}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Kioski safe to operate</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.kioskiStatus}
                                value={contractorWork.kioskiStatus}
                              />
                            }
                          />
                        </GridItem>






                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Meter Information</h4>
                        </GridItem>



                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            labelText="Meter Serial No *"
                            id="meterSerialNo"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.serialNumber,
                              type: "text"
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            labelText="Meter Number *"
                            id="meterNo"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.meterNumber,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            labelText=" Meter Reading  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.meterReading,
                              type: "text"
                            }}
                          />
                        </GridItem>







                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Check List</h4>
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Correct meter installed?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.correctMeterInstalled}
                                value={contractorWork.correctMeterInstalled}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>Meter securely installed?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.meterSecurelyInstalled}
                                value={contractorWork.meterSecurelyInstalled}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>Meter is sealed?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.meterSealed}
                                value={contractorWork.meterSealed}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>Meter is labelled?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.meterLabeled}
                                value={contractorWork.meterLabeled}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>CB in the meter kiosk is secure?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.cbInKioskiSecured}
                                value={contractorWork.cbInKioskiSecured}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>CB in the meter kiosk is labelled?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.cbInKioskiLabeled}
                                value={contractorWork.cbInKioskiLabeled}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>Keypad is labelled?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.keypadLabeled}
                                value={contractorWork.keypadLabeled}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Comms between meter and keypad</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.communicationWithKeypad}
                                value={contractorWork.communicationWithKeypad}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>40kWh token was loaded?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.tokenAdded}
                                value={contractorWork.tokenAdded}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12}>
                          <CustomInput
                            labelText=" Total units after installation  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.totalUnits,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Customer available to sign?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.customerAvailable}
                                value={contractorWork.customerAvailable}
                              />
                            }
                          />
                        </GridItem>


                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Customer Check List</h4>
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>I was advised on how to operate the meter including loading of units and any faults that may arise</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.customerAdviced}
                                value={contractorWork.customerAdviced}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>I've received the prepaid meter card with the correct meter number</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.customerReceivedPrepaymentCard}
                                value={contractorWork.customerReceivedPrepaymentCard}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>I was treated friendly</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={contractorWork.customerTreatedFriendly}
                                value={contractorWork.customerTreatedFriendly}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={6} md={6}>
                          <CustomInput
                            labelText=" Customer Name *"
                            id="customerName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.customerName,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={6} md={6}>
                          <CustomInput
                            labelText=" Customer Phone Number  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.customerContact,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Customer Signature</h4>

                          <Gallery
                            images={customerSignature}
                            enableLightbox={true}
                            enableImageSelection={false}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />

                          <CustomInput
                            labelText=" remarks  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: contractorWork.remarks,
                              type: "text"
                            }}
                          />
                        </GridItem>


                      </GridContainer>
                        : ''}

                    </CardBody>
                  </Card>
                )
              },
              {
                tabButton: "Inspector Submitted Work",
                tabContent: (
                  <Card>
                    <CardBody>

                      <GridContainer xs={12} sm={9} md={9} style={{ margin: "auto", display: !job.postInspectionWork ? 'block' : 'none', }} >
                        <p> No Work Submitted yet</p>
                      </GridContainer>,
  
                    {job.postInspectionWork ? <GridContainer xs={12} sm={9} md={9} style={{ margin: "auto" }} >

                        <GridItem xs={12} sm={12} md={12}>
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Inspector Images</h4>

                          <Gallery
                            images={inspectorImages}
                            enableLightbox={true}
                            enableImageSelection={false}
                          />
                        </GridItem>


                        <GridItem xs={12} sm={12} md={12}>
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Stand Recorded Info</h4>
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you find the stand?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.standFound}
                                value={inspectorWork.standFound}
                              />
                            }

                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you had access into property?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.accessToProperty}
                                value={inspectorWork.accessToProperty}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12}>
                          <CustomInput
                            labelText=" stand comment  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.standComment,
                              type: "text"
                            }}
                          />
                        </GridItem>





                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Kioski Info</h4>
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you locate Kioski?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.kioskiLocated}
                                value={inspectorWork.kioskiLocated}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did you had access into Kioski</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.kioskiAccessLock}
                                value={inspectorWork.kioskiAccessLock}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Kioski safe to operate</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.kioskiStatus}
                                value={inspectorWork.kioskiStatus}
                              />
                            }
                          />
                        </GridItem>






                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Meter Information</h4>
                        </GridItem>



                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            labelText="Meter Serial No *"
                            id="meterSerialNo"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.serialNumber,
                              type: "text"
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            labelText="Meter Number *"
                            id="meterNo"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.meterNumber,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            labelText=" Meter Reading  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.meterReading,
                              type: "text"
                            }}
                          />
                        </GridItem>







                        <GridItem xs={12} sm={12} md={12}>
                          <br />
                          <br />
                          <br />
                          <br />
                          <h4 style={{ fontWeight: "bold", textDecoration: "underline" }} >Check List</h4>
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Acceptable Wiring and Labels?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.acceptableWiringAndLabel}
                                value={inspectorWork.acceptableWiringAndLabel}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>Meter securely installed?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.meterSecurelyInstalled}
                                value={inspectorWork.meterSecurelyInstalled}
                              />
                            }
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Meter is labelled?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.meterLabeled}
                                value={inspectorWork.meterLabeled}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>Meter tempered?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.meterTempered}
                                value={inspectorWork.meterTempered}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>CB in the meter kiosk is secure?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.cbInSecurelyInstalled}
                                value={inspectorWork.cbInSecurelyInstalled}
                              />
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={7} md={7}>
                          <p>CB in the meter kiosk is labelled?</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.cbLabeled}
                                value={inspectorWork.cbLabeled}
                              />
                            }
                          />
                        </GridItem>


                        <GridItem xs={12} sm={7} md={7}>
                          <p>Comms between meter and keypad</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.communicationWithKeypad}
                                value={inspectorWork.communicationWithKeypad}
                              />
                            }
                          />
                        </GridItem>


                        <GridItem xs={12} sm={6} md={6}>
                          <CustomInput
                            labelText="Stand contact person"
                            id="meterSerialNo"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.standContactPerson,
                              type: "text"
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6}>
                          <CustomInput
                            labelText="Stand contact person's number *"
                            id="meterNo"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.standContactPersonPhone,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12}>
                          <CustomInput
                            labelText=" remarks  *"
                            id="meterReading"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              value: inspectorWork.remarks,
                              type: "text"
                            }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={7} md={7}>
                          <p>Did Jobcard Passed</p>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={inspectorWork.isJobcardPassed}
                                value={inspectorWork.isJobcardPassed}
                              />
                            }
                          />
                        </GridItem>



                      </GridContainer>
                        : ''} </CardBody>
                  </Card>
                )
              },
              // {
              //   tabButton: "Management Decision",
              //   tabContent: (
              //     <Card>
              //       <CardBody>

              //         <Card>
              //           <CardHeader color="rose" icon>
              //             <CardIcon color="rose">
              //               <Work />
              //             </CardIcon>
              //             <h2 style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", textTransform: "uppercase" }}>Inspector's Submitted Work</h2>
              //           </CardHeader>
              //           <CardBody>
              //             <centrer>Management Decision</centrer>
              //           </CardBody>
              //         </Card>
              //       </CardBody>
              //     </Card>
              //   )
              // },
              // {
              //   tabButton: "Quality Control",
              //   tabContent: (
              //     <Card>
              //       <CardBody>

              //         <Card>
              //           <CardHeader color="rose" icon>
              //             <CardIcon color="rose">
              //               <Work />
              //             </CardIcon>
              //             <h2 style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline", textTransform: "uppercase" }}>Inspector's Submitted Work</h2>
              //           </CardHeader>
              //           <CardBody>
              //             <centrer>Quality Control</centrer>
              //           </CardBody>
              //         </Card>
              //       </CardBody>
              //     </Card>
              //   )
              // },


            ]}
          />

        </GridItem>
      </GridContainer>

    )
  }
}

export default withStyles(styles)(MeterDisconnection)